import axios from 'axios'

export default axios.create({
    baseURL : "https://poshupakhiapi.porichorja.org/api"
})